import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Popover from '@widget/popups/Popover';
import IconButton from '@widget/buttons/IconButton';
/**
 * @export
 * A self-contained help/info popover — renders a question-mark icon button that
 * opens a structured panel with a title and ordered sections of heading + body text.
 * Content is driven by a simple JSON array so no custom JSX or styles are needed.
 *
 * @example
 * ```tsx
 * <HelpPopover
 *   title="How Navigation Works"
 *   sections={[
 *     {
 *       heading: 'Master Links',
 *       body: 'The single source of truth for all navigation items.',
 *     },
 *     {
 *       heading: 'Navigation Profiles vs User Groups',
 *       body: 'A profile is a curated subset of master links for a user group.',
 *     },
 *   ]}
 * />
 * ```
 */
export const HelpPopover = ({ title, sections, position = 'bottom-right', icon = 'fal circle-question', variant = 'info', }) => {
    const content = () => (_jsx("div", { className: "uxpcore_helppopover__content", children: sections.map((section, index) => (_jsxs("div", { className: "uxpcore_helppopover__section", children: [_jsx("div", { className: "uxpcore_helppopover__heading", children: section.heading }), _jsx("div", { className: "uxpcore_helppopover__body", children: section.body })] }, index))) }));
    return (_jsx(Popover, { title: title, content: content, position: position, children: _jsx(IconButton, { icon: icon, variant: variant }) }));
};
